import React from "react";
import PageHeader from "../../PageHeader";
import ViewAuthUser from "./ViewAuthUser";
// import { ReactComponent as CoursesIcon } from "../../../images/courseimage/coursesicon.svg";
import CoursesIcon from "@material-ui/icons/SupervisorAccount";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";

function AuthUser() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <CoursesIcon />,
      mainheading: "Auth User",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Create New Auth User",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path: "/admin/addauthuser",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <ViewAuthUser />
    </div>
  );
}
export default AuthUser;
